import { render, staticRenderFns } from "./AssessmentsFilter.vue?vue&type=template&id=6cca23ca&scoped=true"
import script from "./AssessmentsFilter.vue?vue&type=script&lang=ts"
export * from "./AssessmentsFilter.vue?vue&type=script&lang=ts"
import style0 from "./AssessmentsFilter.vue?vue&type=style&index=0&id=6cca23ca&prod&lang=css"
import style1 from "./AssessmentsFilter.vue?vue&type=style&index=1&id=6cca23ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cca23ca",
  null
  
)

export default component.exports